var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('Row', [_c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "username",
      "label": "用户名"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('username');
      }
    },
    model: {
      value: _vm.data.username,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "username", $$v);
      },
      expression: "data.username"
    }
  })], 1)], 1), _c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "realname",
      "label": "真实姓名"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('realname');
      }
    },
    model: {
      value: _vm.data.realname,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "realname", $$v);
      },
      expression: "data.realname"
    }
  })], 1)], 1)], 1), _c('Row', [_c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    ref: "password",
    attrs: {
      "prop": "password",
      "label": "密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('password');
      }
    },
    model: {
      value: _vm.data.password,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "password", $$v);
      },
      expression: "data.password"
    }
  })], 1)], 1), _c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    ref: "password2",
    attrs: {
      "prop": "password2",
      "label": "确认密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('password2');
      }
    },
    model: {
      value: _vm.data.password2,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "password2", $$v);
      },
      expression: "data.password2"
    }
  })], 1)], 1)], 1), _c('Row', [_c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('mobile');
      }
    },
    model: {
      value: _vm.data.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "mobile", $$v);
      },
      expression: "data.mobile"
    }
  })], 1)], 1), _c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "email",
      "label": "邮箱"
    }
  }, [_c('IInput', {
    attrs: {
      "maxlength": 50
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('email');
      }
    },
    model: {
      value: _vm.data.email,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "email", $$v);
      },
      expression: "data.email"
    }
  })], 1)], 1)], 1), _c('Row', [_c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "title",
      "label": "岗位"
    }
  }, [_c('IInput', {
    model: {
      value: _vm.data.title,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "title", $$v);
      },
      expression: "data.title"
    }
  })], 1)], 1), _c('ICol', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "employer",
      "label": "工作单位"
    }
  }, [_c('IInput', {
    model: {
      value: _vm.data.employer,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "employer", $$v);
      },
      expression: "data.employer"
    }
  })], 1)], 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: _vm.data.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "remark", $$v);
      },
      expression: "data.remark"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };